import { remoteJobsCategorySlugs } from '@components/common/constant';

export const AccountingJobs = [
  {
    mainHeading: 'Remote Accounting Jobs',
    seeAllLinkTitle: 'See All Remote Accounting Jobs',
    jobDetailLink: '/remote-jobs/accounting',
    childJobs: [
      {
        heading: 'Frontend Developer',
        jobLink: '#',
        city: 'New York',
        jobMoods: [
          'Hybrid Remote Work',
          'Full-Time',
          '125,000.00 - 130,000.00 USD Annually',
        ],
        image: 'https://www.example.com/images/frontend-developer.jpg',
        imageAlt: 'Frontend Developer Logo',
        locationDetails:
          'Candidates need to be able to work in the City or State specified',
      },
      {
        heading: 'Backend Developer',
        jobLink: '#',
        city: 'San Francisco',
        jobMoods: ['Part Time', 'On-Site'],
        image: 'https://www.example.com/images/backend-developer.jpg',
      },
      {
        heading: 'UI/UX Designer',
        jobLink: '#',
        city: 'Austin',
        jobMoods: ['Full Time', 'Hybrid'],
        image: 'https://www.example.com/images/ui-ux-designer.jpg',
      },
    ],
  },
];
export const SoftwareDevelopmentJobs = {
  mainHeading: 'Remote Software Development Jobs',
  SeeAllLinkTitle: 'See All Remote Software Jobs',
  jobDetailLink: '/remote-jobs/software-development',
  childJobs: [
    {
      heading: 'Full Stack Developer',
      city: 'Los Angeles',
      jobMoods: ['Remote', 'Full-Time', '90,000.00 - 120,000.00 USD Annually'],
      image: 'https://www.example.com/images/full-stack-developer.jpg',
      imageAlt: 'Full Stack Developer Logo',
    },
    {
      heading: 'DevOps Engineer',
      city: 'Chicago',
      jobMoods: ['Part Time', 'Remote'],
      image: 'https://www.example.com/images/devops-engineer.jpg',
      imageAlt: 'DevOps Engineer Logo',
    },
    {
      heading: 'Mobile App Developer',
      city: 'Seattle',
      jobMoods: ['Full Time', 'Hybrid'],
      image: 'https://www.example.com/images/mobile-app-developer.jpg',
      imageAlt: 'Mobile App Developer Logo',
    },
    {
      heading: 'Data Scientist',
      city: 'Boston',
      jobMoods: [
        'Full Time',
        'On-Site',
        '120,000.00 - 150,000.00 USD Annually',
      ],
      image: 'https://www.example.com/images/data-scientist.jpg',
      imageAlt: 'Data Scientist Logo',
    },
  ],
};
export const JobLinks = [
  {
    label: 'Remote Companies Q&A',
    JobLinksInner: [
      { label: 'Why Remote', url: '/qa-leading-remote-companies/why-remote' },
      {
        label: 'Hiring Remotely',
        url: '/qa-leading-remote-companies/hiring-remotely',
      },
      {
        label: 'Managing Remotely',
        url: '/qa-leading-remote-companies/managing-remotely',
      },
      {
        label: 'Working Remotely',
        url: '/qa-leading-remote-companies/operating-remotely',
      },
      {
        label: 'Remote Worker Insights',
        url: '/qa-leading-remote-companies/remote-worker-insights',
      },
      {
        label: 'All Questions & Companies',
        url: '/qa-leading-remote-companies',
      },
    ],
  },
  {
    label: 'Remote Workers Q&A',
    JobLinksInner: [
      {
        label: 'All Questions & Workers',
        url: '/remote-workers',
      },
    ],
  },
  {
    label: 'Remote Articles',
    JobLinksInner: [
      { label: 'Why Go Remote', url: '/category/why-go-remote' },
      { label: 'Build a Remote Team', url: '/category/build-a-remote-team' },
      {
        label: 'Remote Management Insights',
        url: '/category/remote-management',
      },
      { label: 'Work Remotely', url: '/category/work-remotely' },
    ],
  },
  {
    label: 'Remote Jobs',
    JobLinksInner: remoteJobsCategorySlugs.map(({ heading, headingLink }) => ({
      label: heading,
      url: headingLink,
    })),
  },
];

export const socialLinks = [
  {
    platform: 'Facebook',
    url: 'https://www.facebook.com/remote.co',
    iconClass: 'fab fa-facebook-f',
  },
  {
    platform: 'Twitter',
    url: 'https://x.com/remote_co',
    iconClass: 'fa-brands fa-x-twitter',
  },
  {
    platform: 'LinkedIn',
    url: 'https://www.linkedin.com/company/remote-co/',
    iconClass: 'fab fa-linkedin-in',
  },
];

export const jobDetailsData = {
  id: 'fd20ba61-1b79-4b14-87a2-122a18b80f8b',
  title: 'Sr senior QA Engineer',
  description: null,
  postedDate: '2024-12-30T05:35:44Z',
  jobLocations: [
    'W C Rices Trailer Park, AZ, A and B Trailer Court Number Two, CA, G. L. Garcia, CO, T Bridge Corner, AR, J and E Junction, AL   (Not hiring in Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Bahamas, Bahrain, Azerbaijan, Austria, AZ, AR, AL, AK, CA)',
  ],
  locations: null,
  allowedCandidateLocation: [
    'W C Rices Trailer Park, AZ, A and B Trailer Court Number Two, CA, G. L. Garcia, CO, T Bridge Corner, AR, J and E Junction, AL   (Not hiring in Albania, Algeria, American Samoa, Andorra, Angola, Anguilla, Bahamas, Bahrain, Azerbaijan, Austria, AZ, AR, AL, AK, CA)',
  ],
  remoteOptions: ['Hybrid Remote Work'],
  jobSchedules: [
    'Full-Time',
    'Part-Time',
    'Flexible Schedule',
    'Alternative Schedule',
  ],
  jobTypes: ['Employee', 'Freelance', 'Temporary'],
  featured: false,
  saved: false,
  slug: 'sr-senior-qa-engineer-fd20ba61-1b79-4b14-87a2-122a18b80f8b',
  createdOn: null,
  expireOn: '2025-02-23T00:00:00Z',
  salaryRange: '1,233.00 - 14.00 AED Weekly',
  applyJobStatus: 'None',
  jobBenefits: [
    'Unlimited or Flexible PTO',
    'Health Insurance',
    'Dental Insurance',
    'Vision Insurance',
    'Life Insurance',
    'Parental Leave',
    'Cell Reimbursement',
    'Internet Reimbursement',
    'Gym / Health Stipend',
    'Office Stipend',
    'Retirement Savings',
    'Continuing Education',
    'Education Assistance',
    'Retreats',
    'Mental Health Support',
    'Disability',
    'Dependent Health',
    'Paid Holidays',
    'Paid Illness Leave',
    'Paid Time Off',
    'Computer Provided',
    'Career Development',
    'Cowork Stipend',
    'Work From Home Stipend',
    'Dogs in Office',
    'Commuter Benefits',
    'Lunch Provided',
    'Complimentary Parking',
    'Relocation Stipend',
    'Snacks Provided',
    'Community Service',
  ],
  categories: [
    {
      name: 'Administrative',
      slug: 'administration-support-services',
      imgSrc: 'streamline-icon-administrative.svg',
    },
    {
      name: 'Collections',
      slug: 'online-collections',
      imgSrc: null,
    },
    {
      name: 'Account Management',
      slug: 'account-management',
      imgSrc: 'streamline-icon-accounting-calculator.svg',
    },
    {
      name: 'Client Services',
      slug: 'online-client-services',
      imgSrc: null,
    },
    {
      name: 'Appointment Setting',
      slug: 'online-appointment-setting',
      imgSrc: null,
    },
    {
      name: 'Banking',
      slug: 'banking',
      imgSrc: null,
    },
  ],
  educationLevels: [
    "Associate's Degree",
    'AA (Arts)',
    'AS (Science)',
    'AAA (Applied Arts)',
    'AAS (Applied Science)',
    'Paralegal',
    'Nursing (ASN)',
    'Information Technology',
    'Technical Degree',
    "Bachelor's/Undergraduate Degree",
    'BA',
    'BS',
    'BFA',
    "Master's Degree",
    'MBA',
    'PA',
    'Doctorate Degree',
    'Ph.D.',
    'JD',
    'DDS',
    'MD',
    'PharmD',
    'DVM',
    'Professional License',
    'CPA',
    'Engineering (PE)',
    'Social Work (LSW, LMSW, LICSW)',
    'Nursing (RN, LPN)',
    'Professional Certification',
    'PMP',
    'HR (PHR, SPHR, SHRM)',
    'Sales (Spin, Sandler, Challenger, etc.)',
    'Network (CCNA, CCNP, CCIE)',
    'Software (Salesforce, etc.)',
    'Google (Analytics, Adwords, etc.)',
    'Health Information (RHIA, RHIT)',
    'Medical Coding (CCA, CCS, CCS-P, CPC)',
  ],
  notes: null,
  company: null,
  applyURL: null,
  jobSummary: 'Short Job Description (Public)*',
  appliedDate: null,
  careerLevel: ['Entry-Level'],
  accolades: [
    {
      name: 'Fast Company - Most Innovative Company',
      url: '/blobcontent/flexjobs/images/icons/acc-fastcompany.png',
      description:
        "Employer is one of Fast Company's Most Innovative Companies.",
    },
    {
      name: 'CareerBliss 50 Happiest Companies in America',
      url: '/blobcontent/flexjobs/images/icons/acc-careerbliss.png',
      description:
        'Employer is one of the 50 Happiest Companies in America, as ranked by CareerBliss.',
    },
    {
      name: 'America’s 100 Best Adoption-Friendly Workplaces',
      url: '/blobcontent/flexjobs/images/icons/acco-dave-thomas.png',
      description:
        'These employers are recognized as having top programs to support adoptive families.',
    },
    {
      name: 'Forbes Most Valuable Brands',
      url: '/blobcontent/flexjobs/images/icons/acco-forbes-tb.png',
      description:
        'These companies have built brand reputations that are trusted by consumers.',
    },
    {
      name: 'Barrons 400',
      url: '/blobcontent/flexjobs/images/barrons400.png',
      description:
        "This employer is one of the well-respected Barron's 400 stock index",
    },
    {
      name: 'Most Ethical Companies',
      url: '/blobcontent/flexjobs/images/mostethicalcompanies.png',
      description:
        "This employer is ranked as one of the World's Most Ethical Companies by Ethisphere",
    },
    {
      name: 'Fortune 100',
      url: '/blobcontent/flexjobs/images/icon-f100.png',
      description: 'Employer is a Fortune 100 Best Company to Work For',
    },
    {
      name: 'Human Rights Campaign Best Places to Work',
      url: '/blobcontent/flexjobs/images/icon-humanrightscampaign.png',
      description:
        'The Human Rights Campaign named this employer as one of the Best Places to Work.',
    },
    {
      name: 'Glassdoor Employees Choice - Best Place to Work',
      url: '/blobcontent/flexjobs/images/icon-50best-black.png',
      description:
        "This company won a Glassdoor Employees' Choice Award for being a Best Place to Work",
    },
    {
      name: "Fortune's Most Admired Companies",
      url: '/blobcontent/flexjobs/images/icon-accolade-fortunes-most-admired.png',
      description:
        "This employer is ranked by Fortune as one of the World's Most Admired Companies.",
    },
    {
      name: "Forbes World's Most Innovative Companies",
      url: '/blobcontent/flexjobs/images/icon-accolade-forbes-I.png',
      description:
        "This employer is ranked by Forbes as one of the World's Most Innovative Companies.",
    },
    {
      name: 'Equal Opportunity Top 50 Employers',
      url: '/blobcontent/flexjobs/images/icon-accolade-eop-top-50.png',
      description:
        'This company is listed as a Top 50 Employer for Equal Opportunity by Equal Opportunity Magazines.',
    },
    {
      name: 'Top 100 Ideal Employers',
      url: '/blobcontent/flexjobs/images/icon-accolade-universum.png',
      description:
        "This company was named one of America's Top 100 Ideal Employers by Universum Global.",
    },
    {
      name: 'The UK Times Top Employers for Women',
      url: '/blobcontent/flexjobs/images/icons/acc-times-top-50.png',
      description:
        'The UK Times recognize this company as a Top Employer for Women.',
    },
    {
      name: "Forbes - World's Most Reputable Companies",
      url: '/blobcontent/flexjobs/images/icons/acc-forbes-mr.svg',
      description:
        "This company was voted by Forbes to be one of the World's Most Reputable Companies",
    },
    {
      name: 'Harris Reputation Quotient Survey',
      url: '/blobcontent/flexjobs/images/icons/acc-harris.png',
      description:
        'Employer scored very good or excellent on the Harris Reputation Quotient Survey.',
    },
    {
      name: 'Fortune 500',
      url: '/blobcontent/flexjobs/images/icon-f500.png',
      description: 'Employer is a Fortune 500 Company',
    },
    {
      name: 'Forbes 2000',
      url: '/blobcontent/flexjobs/images/icon-accolade-forbesglobal.png',
      description:
        'Employer is a Forbes Global 2000 company, a ranking of the biggest, most powerful public companies in the world',
    },
    {
      name: 'Great Places to Work - Best Multinational Workplaces',
      url: '/blobcontent/flexjobs/images/icons/acc-greatplacetowork.png',
      description:
        'Company is multinational in its operations and selected as a Great Place to Work.',
    },
    {
      name: 'Great Places to Work - Best Workplaces for Millennials',
      url: '/blobcontent/flexjobs/images/icons/acc-millennials.png',
      description:
        'Focusing on transparency and workforce demographics, Great Places to Work considers this a Best Workplace for Millennials.',
    },
    {
      name: 'S&P 500',
      url: '/blobcontent/flexjobs/images/sp500.png',
      description:
        'Company is one of the S&P 500, a leading index of public large-cap American stocks',
    },
    {
      name: '50 Best Companies for Latinas',
      url: '/blobcontent/flexjobs/images/icons/acco-latina.png',
      description:
        'Employers that offer the best career opportunities for Latinas in the U.S.',
    },
    {
      name: 'Department of Defense Military Spouse Employment Partner - MSEP',
      url: '/blobcontent/flexjobs/images/icons/acc-msep.png',
      description:
        'The U.S. Department of Defense recognizes this employer as a Military Spouse Employment Partner (MSEP)',
    },
    {
      name: 'MCCA Employer of Choice Award',
      url: '/blobcontent/flexjobs/images/icons/acc-mcca.png',
      description:
        'Outstanding law department leading the charge in change and helping diverse attorneys break through the concrete ceiling.',
    },
    {
      name: "Forbes America's Best Employers for Diversity",
      url: '/blobcontent/flexjobs/images/icons/acc-forbes-diversity.png',
      description:
        "Employer named by Forbes and Statista as one of America's Best Employers for Diversity.",
    },
    {
      name: "Fortune's Change the World",
      url: '/blobcontent/flexjobs/images/icons/fortunectw2x.png',
      description:
        "This employer is ranked by Fortune as a company dedicated to addressing society's biggest challenges.",
    },
  ],
  reportJobStatus: false,
  travelRequired: 'No specification',
  regionID: [0],
  states: ['AZ', 'CA', 'CO', 'AR', 'AL'],
  countries: ['United States'],
  cities: [
    'W C Rices Trailer Park',
    'A and B Trailer Court Number Two',
    'G. L. Garcia',
    'T Bridge Corner',
    'J and E Junction',
  ],
  eligibleForExpertApply: false,
  isFreeJob: false,
  ats: null,
  score: 0,
  matchID: '00000000-0000-0000-0000-000000000000',
  postalCode: null,
};
export const DasboardTabData = [
  {
    tabTitle: 'suggested job',
    jobCount: 10,
    tabData: [
      {
        heading: '1 Frontend Developer',
        jobLink: '#',
        city: ['New York'],
        jobMoods: [
          'Hybrid Remote Work',
          'Full-Time',
          '125,000.00 - 130,000.00 USD Annually',
        ],
        image: 'https://www.example.com/images/frontend-developer.jpg',
        imageAlt: 'Frontend Developer Logo',
        locationDetails:
          'Candidates need to be able to work in the City or State specified',
      },
      {
        heading: 'Backend Developer',
        jobLink: '#',
        city: ['San Francisco'],
        jobMoods: ['Part Time', 'On-Site'],
        image: 'https://www.example.com/images/backend-developer.jpg',
      },
      {
        heading: 'UI/UX Designer',
        jobLink: '#',
        city: ['Austin'],
        jobMoods: ['Full Time', 'Hybrid'],
        image: 'https://www.example.com/images/ui-ux-designer.jpg',
      },
    ],
  },
  {
    tabTitle: 'Saved job',
    jobCount: 8,
    tabData: [
      {
        heading: '2 Backend Developer',
        jobLink: '#',
        city: ['San Francisco'],
        jobMoods: ['Part Time', 'On-Site'],
        image: 'https://www.example.com/images/backend-developer.jpg',
      },
      {
        heading: 'UI/UX Designer',
        jobLink: '#',
        city: ['Austin'],
        jobMoods: ['Full Time', 'Hybrid'],
        image: 'https://www.example.com/images/ui-ux-designer.jpg',
      },
    ],
  },
  {
    tabTitle: 'Viewed Jobs',
    jobCount: 85,
    tabData: [
      {
        heading: '3 Backend Developer',
        jobLink: '#',
        city: ['San Francisco'],
        jobMoods: ['Part Time', 'On-Site'],
        image: 'https://www.example.com/images/backend-developer.jpg',
      },
      {
        heading: 'UI/UX Designer',
        jobLink: '#',
        city: ['Austin'],
        jobMoods: ['Full Time', 'Hybrid'],
        image: 'https://www.example.com/images/ui-ux-designer.jpg',
      },
    ],
  },
  {
    tabTitle: 'Applied job',
    jobCount: 0,
    tabData: [
      {
        heading: '4 Backend Developer',
        jobLink: '#',
        city: ['San Francisco'],
        jobMoods: ['Part Time', 'On-Site'],
        image: 'https://www.example.com/images/backend-developer.jpg',
      },
      {
        heading: 'UI/UX Designer',
        jobLink: '#',
        city: ['Austin'],
        jobMoods: ['Full Time', 'Hybrid'],
        image: 'https://www.example.com/images/ui-ux-designer.jpg',
      },
    ],
  },
  {
    tabTitle: 'Saved Searches',
    jobCount: 4,
    tabData: [
      {
        jobHeading: 'Customer_Experience_Associate',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: true,
        date: '17 Dec',
      },
      {
        jobHeading: 'Customer Associate',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: false,
        date: '21 Dec',
      },
      {
        jobHeading: 'Software Engineer ',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: false,
        date: '10 Dec',
      },
    ],
  },
  {
    tabTitle: 'resumes',
    jobCount: 2,
    tabData: [
      {
        jobHeading: 'Customer_Experience_Associate',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: true,
        date: '17 Dec',
      },
      {
        jobHeading: 'Customer Associate',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: false,
        date: '21 Dec',
      },
      {
        jobHeading: 'Software Engineer ',
        jobLink:
          '/remote-jobs/search?savedsearch=customer_experience_associate',
        jobNotification: false,
        date: '10 Dec',
      },
    ],
  },
];
export const SettingsData = [
  {
    tabTitle: 'Contact Information',
    tabData: [
      {
        labelName: 'First Name',
        inputType: 'text',
        isRequired: true,
      },
      {
        labelName: 'Last Name',
        inputType: 'text',
        isRequired: true,
      },
      {
        labelName: 'Zip Code',
        inputType: 'text',
      },
      {
        labelName: 'State',
        inputType: 'selectDropdown',
        optionValues: ['MP', 'UP', 'CG'],
      },
      {
        labelName: 'Country',
        inputType: 'selectDropdown',
        optionValues: ['India', 'China', 'USA'],
      },
      {
        labelName: 'Phone Number',
        inputType: 'text',
      },
    ],
  },
  {
    tabTitle: 'Email Preferences',
    notificationTitle: 'Core Remote.co Emails',
    tabData: [
      {
        labelName: 'Email Address',
        inputType: 'email',
        isRequired: true,
      },
      {
        labelName: 'Job Notifications',
        inputType: 'checkbox',
        inputDetails: `Receive a daily email when a new job is posted (or jobs) to categories matching your interests as you've outlined in your Resume Profile(s) and/or any Saved Searches.`,
      },
      {
        labelName: 'The Weekly Newsletter',
        inputType: 'checkbox',
        inputDetails: `A weekly email newsletter highlighting site updates, popular blog posts, company news, special offers, and featured jobs. Typically sent on Wednesdays.`,
      },
    ],
  },
  {
    tabTitle: 'Password',
    tabData: [
      {
        labelName: 'New Password',
        inputType: 'password',
        isRequired: true,
      },
      {
        labelName: 'Confirm New Password',
        inputType: 'password',
        isRequired: true,
      },
    ],
  },
  {
    tabTitle: 'Billing',
    tabData: [],
  },
  {
    tabTitle: 'Subscription',
    tabData: [],
  },
];
